import React from "react";
import { motion } from "framer-motion";
const fadeInAnimationVariants = {
    initial: { opacity: 0, y: 50 },
    animate: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.05 * index },
    }),
  };
const data = [
  {
    parameter: "Theoretical Foundation",
    skillsphere: "Multi-model integration",
    conventional: "Single-dimension focus",
  },
  {
    parameter: "Output Granularity",
    skillsphere: "Trait interaction analysis",
    conventional: "Isolated score reporting",
  },
  {
    parameter: "Developmental Utility",
    skillsphere: "Prescriptive pathway modeling",
    conventional: "Descriptive reporting only",
  },
  {
    parameter: "Stakeholder Utility",
    skillsphere: "Role-specific interpretation frameworks",
    conventional: "Generic recommendations",
  },
];

export default function AssessmentComparison() {
  return (
    <div   className="bg-gray-100 py-10 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto">
        <motion.div variants={fadeInAnimationVariants}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }} className="text-2xl sm:text-3xl font-bold text-center mb-8 font-montserrat" style={{ fontFamily: "Montserrat" }}>
          Skillsphere Assessment <span className="text-blue-500">Vs</span> Conventional Assessments
        </motion.div>

        {/* Table layout for md and above */}
        <motion.div variants={fadeInAnimationVariants}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }} className="border border-gray-200 rounded-lg shadow-sm bg-white overflow-hidden hidden md:block">
          <div className="comparison-scroll-container">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="bg-fuchsia-600 text-white text-sm sm:text-base px-4 py-3 text-center sticky top-0 font-poppins min-w-[200px]" style={{ fontFamily: "Montserrat" }}>
                    Parameter
                  </th>
                  <th className="bg-blue-500 text-white text-sm sm:text-base px-4 py-3 text-center sticky top-0 font-poppins font-semibold min-w-[250px]" style={{ fontFamily: "Montserrat" }}>
                    Skillsphere Assessment
                  </th>
                  <th className=" bg-green-500 text-white text-sm sm:text-base px-4 py-3 text-center sticky top-0 font-poppins font-semibold min-w-[250px]" style={{ fontFamily: "Montserrat" }}>
                    Conventional Assessment
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, idx) => (
                  <tr key={idx} className="even:bg-gray-50">
                    <td className="bg-pink-100 px-4 py-4 text-sm sm:text-base text-center font-poppins" style={{ fontFamily: "Poppins" }}>
                      {row.parameter}
                    </td>
                    <td className="bg-blue-100 px-4 py-4 text-sm sm:text-base text-center font-poppins" style={{ fontFamily: "Poppins" }}>
                      {row.skillsphere}
                    </td>
                    <td className=" bg-green-50 px-4 py-4 text-sm sm:text-base text-center font-poppins" style={{ fontFamily: "Poppins" }}>
                      {row.conventional}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </motion.div>

        {/* Column layout for small screens */}
        <motion.div variants={fadeInAnimationVariants}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }} className="block md:hidden space-y-4">
          {data.map((row, idx) => (
            <div key={idx} className="bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="bg-fuchsia-600 px-4 py-3 font-poppins text-sm font-semibold text-center text-white" style={{ fontFamily: "Poppins" }}>
                {row.parameter}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2">
                <div className=" bg-blue-100 px-4 py-3 text-sm text-center font-poppins">
                  <span className="block font-semibold  text-blue-800 mb-1" style={{ fontFamily: "Poppins" }}>Skillsphere Assessment</span>
                  {row.skillsphere}
                </div>
                <div className="bg-green-50 px-4 py-3 text-sm text-center font-poppins">
                  <span className="block font-semibold text-green-800 mb-1" style={{ fontFamily: "Poppins" }}>Conventional Assessment</span>
                  {row.conventional}
                </div>
              </div>
            </div>
          ))}
        </motion.div>

      </div>
    </div>   
  );
}
